import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import DiscoveryConfigFormPage from "../../components/DiscoveryConfig/DiscoveryConfigFormPage";



const AddDiscoveryConfigPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb id="title" title="Add Compatibility Algorithm" title2="Compatibility Algorithm" link2="/discovery-config" />
        <DiscoveryConfigFormPage />
      </MasterLayout>
    </>
  );
};

export default AddDiscoveryConfigPage;
